import { Card, LicensePlate, Text } from '@velocity/ui'
import * as React from 'react'
import { Form } from 'react-final-form'

import { useContent } from '@ngb-frontend/shared/context'
import {
  DRIVER_STEP_FORM_ID,
  MileageField,
  StepFooterDisabledSync,
} from '@ngb-frontend/shared/ui'

import { useMileageFormStyles } from './MileageForm.styled'

import type {
  MileageFormValues,
  StepFormProps,
} from '@ngb-frontend/shared/types'

interface MileageFormProps extends StepFormProps<MileageFormValues> {
  vehicleName?: string
  licensePlate?: string
}

export const MileageForm: React.FC<MileageFormProps> = ({
  initialValues,
  onSubmit,
  vehicleName,
  licensePlate,
}) => {
  const c = useContent()
  const classes = useMileageFormStyles()
  const handleSubmit = React.useCallback(
    (values: MileageFormValues) => {
      onSubmit?.({ mileage: Number(values.mileage) }) // submitted as string
    },
    [onSubmit],
  )

  return (
    <Form<MileageFormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
    >
      {(formProps) => (
        <form
          id={DRIVER_STEP_FORM_ID}
          onSubmit={formProps.handleSubmit}
          data-e2e-component="mileage-form"
        >
          <Card data-e2e-component="mileage-card">
            <Card.Body>
              <div className={classes.label}>
                <Text
                  variant="200"
                  bold
                  data-e2e-component="mileage-card-label"
                >
                  {vehicleName
                    ? c('steps.mileage.cardLabel', {
                        variables: { vehicle: vehicleName },
                      })
                    : c('fields.mileage.label')}
                </Text>
                {licensePlate && (
                  <LicensePlate size="s">{licensePlate}</LicensePlate>
                )}
              </div>
              <div className={classes.field}>
                <MileageField
                  hideLabel
                  noMargin
                  placeholder={c('fields.mileage.label')}
                />
              </div>
            </Card.Body>
          </Card>
          <StepFooterDisabledSync disabled={formProps.invalid} />
        </form>
      )}
    </Form>
  )
}
